/**
 * @Description:
 * @Author: huage
 * @Date: 2020/9/17
 */
export default {
    common: {
        "confirm": "确认",
        "cancle": "取消",
        "add": "新增",
        "edit": "编辑",
        "delete": "删除",
        "save": "保存",
        "disable": "禁用",
        "enable": "启用",
        "back": "返回",
        "message1": "修改密码成功",
        "placeholder1": "请输入新密码",
        "placeholder2": "请输入确认密码",
        "placeholder3": "数字、字母、中划线或下划线组合",
        "placeholder4": "请输入用户名",
        "placeholder5": "用户名不能大于20个字符",
        "placeholder6": "只能输入数字、字母、中划线或下划线",
        "placeholder7": "请选择",
      }
};


// WEBPACK FOOTER //
// ./src/config/langs/zh_CN/common.js